<div mat-dialog-content>

  <div>

    <div>
      <div class="row" style="margin-left: 3px; margin-bottom: 3px;">
        <div class="col-md-4">
          <mat-form-field>
            <mat-label>Virtual Container Name</mat-label>
            <input type="text" matInput name="virtualname" [(ngModel)]="virtualContainerName" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div class="col-md-2">
          <button type="button" class="btn btn-success btn-md" (click)="addVirtualContainer()" [disabled]="virtualContainerName === '' || savingcontainer">
            <i *ngIf="!savingcontainer" class="fa fa-plus" aria-hidden="true"></i>
            <i *ngIf="savingcontainer" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
            &nbsp; New Virtual Container
          </button>
        </div>
      </div>
    </div>

    <div style="background-color: #F2F3F4;">

      <div class="row" style="margin-left: 3px; margin-right: 3px;">
        
        <div class="col-md-6">
          <div class="form-group">
            <label class="bmd-label-floating"><b>Virtual Container Inventory</b> &nbsp;
              <i *ngIf="loadingContainers" class="fa fa-spinner fa-pulse fa-fw"></i>
            </label>
            <app-filter-object
            *ngIf="!loadingContainers"
              [options]="virtualContainers"
              (selectChange)="selectVirtualContainer($event)"
            ></app-filter-object>
          </div>
        </div>
        
      </div>

    </div>

    <br>
    
    <button type="button" class="btn btn-primary btn-md" (click)="saveVirtualContainer()" [disabled]="containerSelected === 0">
        <i class="fa fa-floppy-o" aria-hidden="true"></i>
        &nbsp; Add To Virtual Container
      </button>

  </div>

</div>

<div mat-dialog-actions>
  <button mat-button class="btn btn-default" (click)="onCancelClick()">Close</button>
  <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
  <!-- <button mat-button class="btn btn-primary" (click)="onSave()"
          [disabled]="saving || !f.dirty"
          cdkFocusInitial>
    <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
    <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
    Save
  </button> -->
</div>
